// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Ensure main content starts below the fixed profile card */
.main-content {
  padding-top: 120px; /* Enough to push content below profile card */
}

/* Optional: Prevent extra spacing on desktop */
@media (min-width: 768px) {
  .main-content {
    padding-top: 100px;
  }
}

.navbar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  background-color: white; /* or your navbar color */
}

.contain {
  display: flex;
  height: -moz-fit-content;
  height: fit-content;
  align-items: flex-start;
  justify-content: center;
}

.main-content {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
}

.stats-header {
  text-align: center;
  margin: 45px 0px 0px 30px;
}

.stats-container {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  justify-content: center;
  /* padding: 70px; */
  flex-direction: column;
  margin-top: 160px;
}

.stat-box {
  position: relative;
  background-color: #fff;
  box-shadow: 0 2px 7px rgba(0, 0, 0, 0.5);
  width: 48%;

  margin: 10px;
  box-sizing: border-box;
  text-align: center;
  border-radius: 10px;
  padding: 10px;
  justify-content: space-around;
  /* gap: 20px; */
  /* margin-top: 70px; */
  margin-bottom: 10px;
}

.stat-number {
  font-size: 1.5em;
  margin: 80px 0;
}

.stat-field {
  background-color: #2865aa;
  color: white;
  padding: 10px;
  margin-top: 10px;

  border-radius: 15px;
  margin-bottom: 20px;
}

.plus-icon {
  position: absolute;
  top: -15px;
  right: -15px;
  width: 40px;
  height: 40px;
  cursor: pointer;
}

.stats-row {
  display: flex;
  flex-wrap: wrap;
  gap: 40px;
  justify-content: center;
  align-items: center;
}

.profile-card {
  position: fixed;
  top: 60px; /* Adjust depending on your navbar height */
  left: 0;
  right: 0;
  margin: auto;
  width: 90%;
  z-index: 999;
  background: white;
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  padding: 12px;
}

/* Increase the top margin for the first row */
/* .stats-row:first-child .stat-box { */
/* margin-top: 20px; */
/* Adjust the margin as needed */
/* } */

/* Decrease the space between the second row boxes */
/* .stats-row:last-child .stat-box { */
/* margin-bottom: 0px; */
/* Reduce space between the boxes */
/* } */

/* Optional: Adjust the bottom margin for all stat boxes */
/* .stat-box { */
/* margin-bottom: 0px; */
/* Set an appropriate margin bottom to space out boxes */
/* } */

/* Desktop Layout - 3 Columns */
@media (min-width: 768px) {
  .stats-container {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    text-align: center;
    border-radius: 10px;
    margin-top: 50px;
  }

  .stat-box {
    width: 25%;
    /* For larger screens, 3 boxes per row */
    margin-top: 10px;
    /* Reduce top margin */
    margin-bottom: 10px;
    /* Reduce bottom margin */
  }

  .plus-icon {
    position: absolute;
    top: -12px;
    right: -12px;
    width: 50px;
    height: 50px;
  }

  .stat-field {
    background-color: #2865aa;
    color: white;
    padding: 15px;
    margin-top: 70px;
    /* Reduce space between number and field */
    border-radius: 15px;
    /* margin-bottom: 90px; */
    /* Reduce bottom margin of stat-field */
    margin-left: 30px;
    margin-right: 30px;
  }
}

/* Profile Card - Mobile View */
.profile-card {
  background-color: white;
  border-radius: 10px;
  position: fixed;
  top: 20vw;
  left: 50%;
  transform: translateX(-50%);
  height: 100px;
  display: flex;
  align-items: center;
  gap: 15px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.2);
  width: calc(100% - 50px);
  padding: 0 20px;
  z-index: 1000;
}

.profile-img {
  height: 70px;
  width: 70px;
  border-radius: 50%;
  object-fit: cover;
}

.profile-text h1 {
  font-size: 18px;
  margin: 0;
}

.profile-text h3 {
  font-size: 14px;
  color: gray;
  margin: 0;
}

/* Mobile Layout - 2 Columns and 3 Rows */
@media (max-width: 768px) {
  .stats-header {
    display: none;
  }
  .main-content {
    padding-top: 0px;
  }

  .stats-container {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    /* 2 columns */
    gap: 10px;
    /* Reduce gap between grid items */
    /* justify-items: center; */
  }

  .stat-box {
    width: 100%;
    /* Take full width of grid cells */
    /* margin-top: 200px; */
    /* Reduce top margin */
    /* Reduce bottom margin */
    /* justify-content: space-between; */
    margin-right: 20px;
    margin-left: 20px;
    /* height: 200px; */
  }

  .plus-icon {
    width: 30px;
    height: 30px;
  }

  .stat-number {
    font-size: 1.2em;
  }

  .stat-field {
    font-size: 12px;
    padding: 8px;
    /* background-color: #2865aa;
    color: white;
    padding: 15px; */
    margin-top: 0px;
  }

  .stats-row {
    display: flex;
    flex-wrap: wrap;
    gap: 0px;
    /* justify-content: center; */
    /* align-items: center; */
  }

  .stat-number {
    font-size: 1.5em;
    margin: 20px 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/home.css"],"names":[],"mappings":"AAAA,4DAA4D;AAC5D;EACE,kBAAkB,EAAE,8CAA8C;AACpE;;AAEA,+CAA+C;AAC/C;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,aAAa;EACb,uBAAuB,EAAE,yBAAyB;AACpD;;AAEA;EACE,aAAa;EACb,wBAAmB;EAAnB,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,wCAAwC;EACxC,UAAU;;EAEV,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,6BAA6B;EAC7B,eAAe;EACf,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,gBAAgB;;EAEhB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,SAAS,EAAE,2CAA2C;EACtD,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,iBAAiB;EACjB,0CAA0C;EAC1C,mBAAmB;EACnB,aAAa;AACf;;AAEA,8CAA8C;AAC9C,uCAAuC;AACvC,sBAAsB;AACtB,gCAAgC;AAChC,MAAM;;AAEN,oDAAoD;AACpD,sCAAsC;AACtC,wBAAwB;AACxB,mCAAmC;AACnC,MAAM;;AAEN,0DAA0D;AAC1D,gBAAgB;AAChB,wBAAwB;AACxB,wDAAwD;AACxD,MAAM;;AAEN,+BAA+B;AAC/B;EACE;IACE,aAAa;IACb,eAAe;IACf,8BAA8B;IAC9B,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,UAAU;IACV,wCAAwC;IACxC,gBAAgB;IAChB,sBAAsB;IACtB,mBAAmB;IACnB,yBAAyB;EAC3B;;EAEA;IACE,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,WAAW;IACX,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,YAAY;IACZ,aAAa;IACb,gBAAgB;IAChB,0CAA0C;IAC1C,mBAAmB;IACnB,yBAAyB;IACzB,uCAAuC;IACvC,iBAAiB;IACjB,kBAAkB;EACpB;AACF;;AAEA,+BAA+B;AAC/B;EACE,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,2CAA2C;EAC3C,wBAAwB;EACxB,eAAe;EACf,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,SAAS;AACX;;AAEA;EACE,eAAe;EACf,WAAW;EACX,SAAS;AACX;;AAEA,yCAAyC;AACzC;EACE;IACE,aAAa;EACf;EACA;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,qCAAqC;IACrC,cAAc;IACd,SAAS;IACT,kCAAkC;IAClC,2BAA2B;EAC7B;;EAEA;IACE,WAAW;IACX,kCAAkC;IAClC,uBAAuB;IACvB,sBAAsB;IACtB,yBAAyB;IACzB,oCAAoC;IACpC,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,YAAY;IACZ;;oBAEgB;IAChB,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,eAAe;IACf,QAAQ;IACR,6BAA6B;IAC7B,yBAAyB;EAC3B;;EAEA;IACE,gBAAgB;IAChB,cAAc;EAChB;AACF","sourcesContent":["/* Ensure main content starts below the fixed profile card */\n.main-content {\n  padding-top: 120px; /* Enough to push content below profile card */\n}\n\n/* Optional: Prevent extra spacing on desktop */\n@media (min-width: 768px) {\n  .main-content {\n    padding-top: 100px;\n  }\n}\n\n.navbar {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  z-index: 1000;\n  background-color: white; /* or your navbar color */\n}\n\n.contain {\n  display: flex;\n  height: fit-content;\n  align-items: flex-start;\n  justify-content: center;\n}\n\n.main-content {\n  flex-grow: 1;\n  display: flex;\n  flex-direction: column;\n  overflow-y: auto;\n}\n\n.stats-header {\n  text-align: center;\n  margin: 45px 0px 0px 30px;\n}\n\n.stats-container {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 20px;\n  justify-content: center;\n  /* padding: 70px; */\n  flex-direction: column;\n  margin-top: 160px;\n}\n\n.stat-box {\n  position: relative;\n  background-color: #fff;\n  box-shadow: 0 2px 7px rgba(0, 0, 0, 0.5);\n  width: 48%;\n\n  margin: 10px;\n  box-sizing: border-box;\n  text-align: center;\n  border-radius: 10px;\n  padding: 10px;\n  justify-content: space-around;\n  /* gap: 20px; */\n  /* margin-top: 70px; */\n  margin-bottom: 10px;\n}\n\n.stat-number {\n  font-size: 1.5em;\n  margin: 80px 0;\n}\n\n.stat-field {\n  background-color: #2865aa;\n  color: white;\n  padding: 10px;\n  margin-top: 10px;\n\n  border-radius: 15px;\n  margin-bottom: 20px;\n}\n\n.plus-icon {\n  position: absolute;\n  top: -15px;\n  right: -15px;\n  width: 40px;\n  height: 40px;\n  cursor: pointer;\n}\n\n.stats-row {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 40px;\n  justify-content: center;\n  align-items: center;\n}\n\n.profile-card {\n  position: fixed;\n  top: 60px; /* Adjust depending on your navbar height */\n  left: 0;\n  right: 0;\n  margin: auto;\n  width: 90%;\n  z-index: 999;\n  background: white;\n  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.1);\n  border-radius: 10px;\n  padding: 12px;\n}\n\n/* Increase the top margin for the first row */\n/* .stats-row:first-child .stat-box { */\n/* margin-top: 20px; */\n/* Adjust the margin as needed */\n/* } */\n\n/* Decrease the space between the second row boxes */\n/* .stats-row:last-child .stat-box { */\n/* margin-bottom: 0px; */\n/* Reduce space between the boxes */\n/* } */\n\n/* Optional: Adjust the bottom margin for all stat boxes */\n/* .stat-box { */\n/* margin-bottom: 0px; */\n/* Set an appropriate margin bottom to space out boxes */\n/* } */\n\n/* Desktop Layout - 3 Columns */\n@media (min-width: 768px) {\n  .stats-container {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: space-between;\n    text-align: center;\n    border-radius: 10px;\n    margin-top: 50px;\n  }\n\n  .stat-box {\n    width: 25%;\n    /* For larger screens, 3 boxes per row */\n    margin-top: 10px;\n    /* Reduce top margin */\n    margin-bottom: 10px;\n    /* Reduce bottom margin */\n  }\n\n  .plus-icon {\n    position: absolute;\n    top: -12px;\n    right: -12px;\n    width: 50px;\n    height: 50px;\n  }\n\n  .stat-field {\n    background-color: #2865aa;\n    color: white;\n    padding: 15px;\n    margin-top: 70px;\n    /* Reduce space between number and field */\n    border-radius: 15px;\n    /* margin-bottom: 90px; */\n    /* Reduce bottom margin of stat-field */\n    margin-left: 30px;\n    margin-right: 30px;\n  }\n}\n\n/* Profile Card - Mobile View */\n.profile-card {\n  background-color: white;\n  border-radius: 10px;\n  position: fixed;\n  top: 20vw;\n  left: 50%;\n  transform: translateX(-50%);\n  height: 100px;\n  display: flex;\n  align-items: center;\n  gap: 15px;\n  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.2);\n  width: calc(100% - 50px);\n  padding: 0 20px;\n  z-index: 1000;\n}\n\n.profile-img {\n  height: 70px;\n  width: 70px;\n  border-radius: 50%;\n  object-fit: cover;\n}\n\n.profile-text h1 {\n  font-size: 18px;\n  margin: 0;\n}\n\n.profile-text h3 {\n  font-size: 14px;\n  color: gray;\n  margin: 0;\n}\n\n/* Mobile Layout - 2 Columns and 3 Rows */\n@media (max-width: 768px) {\n  .stats-header {\n    display: none;\n  }\n  .main-content {\n    padding-top: 0px;\n  }\n\n  .stats-container {\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n    /* 2 columns */\n    gap: 10px;\n    /* Reduce gap between grid items */\n    /* justify-items: center; */\n  }\n\n  .stat-box {\n    width: 100%;\n    /* Take full width of grid cells */\n    /* margin-top: 200px; */\n    /* Reduce top margin */\n    /* Reduce bottom margin */\n    /* justify-content: space-between; */\n    margin-right: 20px;\n    margin-left: 20px;\n    /* height: 200px; */\n  }\n\n  .plus-icon {\n    width: 30px;\n    height: 30px;\n  }\n\n  .stat-number {\n    font-size: 1.2em;\n  }\n\n  .stat-field {\n    font-size: 12px;\n    padding: 8px;\n    /* background-color: #2865aa;\n    color: white;\n    padding: 15px; */\n    margin-top: 0px;\n  }\n\n  .stats-row {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 0px;\n    /* justify-content: center; */\n    /* align-items: center; */\n  }\n\n  .stat-number {\n    font-size: 1.5em;\n    margin: 20px 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
